export const listPlants = (plants) => {
    return {
      type: "LIST_PLANTS",
      payload: plants,
    };
  };

export const filterPlantName = (plantName) => {
    return {
      type: "FILTER_PLANT_NAME",
      payload: plantName,
    };
  };

  export const plantInfo = (plantData) => {
    return {
      type: "PLANT_DATA",
      payload: plantData,
    };
  };

  export const areaDetails = (areaId) => {
    return {
      type: "AREA_DETAILS",
      payload: areaId,
    };
  };